import { useEffect } from "react"
// @ts-expect-error - @rails/actioncable doesn't have TypeScript declarations
import * as ActionCable from "@rails/actioncable"

interface UseEmailAccountUsageProps {
  onUpdate: (accountId: number) => void
}

export const useEmailAccountUsage = ({
  onUpdate,
}: UseEmailAccountUsageProps) => {
  useEffect(() => {
    const cable = ActionCable.createConsumer()

    const subscription = cable.subscriptions.create(
      { channel: "EmailAccountsChannel" },
      {
        received: (data: { type: string; account_id: number }) => {
          if (data.type === "usage_update") {
            onUpdate(data.account_id)
          }
        },
      },
    )

    return () => {
      subscription.unsubscribe()
    }
  }, [onUpdate])
}
